import React, { Component, useRef, useState } from "react";
import {
    DataGrid,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem,
} from "devextreme-react/data-grid";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import uiInfo from "../ui-info";
import api from "../api-axios";
import { ButtonItem } from "devextreme-react/tree-list";
import UserInfo from "../UserInfo";
import notify from "devextreme/ui/notify";
import { LoadIndicator } from "devextreme-react/load-indicator";

const localStorageKey = "cadastroContribuinteGridState";

const RestaurarNfseBox = () => {

    let _gridInstance = useRef();
    let _formInstance = useRef();

    const [cpfCnpj, setCpfCnpj] = useState("");
    const [numeroNf, setNumeroNf] = useState();
    const [exercicio, setExercicio] = useState();
    const [notas, setNotas] = useState([]);
    const [msgCarregando, setMsgCarregando] = useState("");

    const carregarDados = async () => {
        setMsgCarregando("Buscando Notas");

        var dadosRequisicao = {
            prefeituraId: UserInfo.getPrefeitura(),
            cpfCnpj,
            exercicio,
            numeroNf
        };

        try {
            var response = await api.post("/nfse/notas_restaurar", dadosRequisicao);
            setNotas(response.data);
            setMsgCarregando("");
        }
        catch (error) {
            notify(error, "error");
        }
        finally {
            setMsgCarregando("");
        }
    }

    const restaurarNf = async (e) => {

        setMsgCarregando("Restaurando NFS-e");

        var dadosRequisicao = {
            prefeituraId: UserInfo.getPrefeitura(),
            nfseId: e.row.key
        };

        try {
            await api.post("/nfse/restaurar_nf", dadosRequisicao);
            notify("NFS-e restaurada com sucesso", "success");
        }
        catch (error) {
            notify(error, "error");
        }
        finally {
            setMsgCarregando("");
            carregarDados();
        }
    }

    const limparFiltro = () => {

        setMsgCarregando("Limpando filtros");
        setCpfCnpj("");
        setExercicio(null);
        setNumeroNf(null);
        setNotas([]);
        setMsgCarregando("");

    }



    if (msgCarregando != "") {
        return (
            <div className={"content-block dx-card responsive-paddings"}>
                <div
                    style={{
                        display: "flex",
                        marginTop: "25px",
                        justifyContent: "center",
                        alignContent: "center",
                        justifyItems: "center",
                        alignItems: "center",
                        flexDirection: "column"
                    }}
                >
                    <LoadIndicator width={60} height={60} />
                    <h3>{msgCarregando}</h3>
                </div>
            </div>
        );
    }


    return (
        <React.Fragment>
            <div className={"content-block dx-card responsive-paddings"}>
                <h2 style={{ textAlign: "center" }}>RESTAURAR NFS-e</h2>
                <br />
                <form>
                    <Form id="frmPesquisa" colCount={9} ref={frm => _formInstance = frm}>
                        <SimpleItem name={"cpfCnpj"} colSpan={3} editorType={"dxTextBox"} editorOptions={{ value: cpfCnpj, onValueChanged: (e) => setCpfCnpj(e.value) }}>
                            <Label text="CPF/CNPJ" />
                        </SimpleItem>
                        <SimpleItem
                            editorType={"dxNumberBox"}
                            colSpan={2}
                            editorOptions={{ step: 0, value: exercicio, onValueChanged: (e) => setExercicio(e.value) }}
                        >
                            <Label text="Exercício" />
                        </SimpleItem>
                        <SimpleItem
                            editorType={"dxNumberBox"}
                            colSpan={2}
                            editorOptions={{ step: 0, value: numeroNf, onValueChanged: (e) => setNumeroNf(e.value) }}
                        >
                            <Label text="Numero NF" />
                        </SimpleItem>

                        <ButtonItem buttonOptions={{ text: "Filtrar", type: "success", width: "100%", onClick: carregarDados }} />
                        <ButtonItem buttonOptions={{ text: "Limpar", width: "100%", onClick: limparFiltro }} />
                    </Form>
                </form>
                <br />
                <br />
                <h3> Lista de Notas</h3>
                <DataGrid
                    ref={(grid) => (_gridInstance = grid)}
                    dataSource={notas}
                    showBorders={true}
                    rowAlternationEnabled={true}
                    remoteOperations={true}
                    columnAutoWidth={true}
                    focusedRowEnabled={true}
                    wordWrapEnabled={window.innerWidth < 800}
                    filterSyncEnabled={true}
                    keyExpr={"id"}>
                    <Column
                        type="buttons"
                        fixed={true}
                        fixedPosition={"left"}
                        buttons={[
                            "edit",
                            "delete",
                            {
                                hint: "Restaurar",
                                icon: "undo",
                                onClick: (e) => restaurarNf(e)
                            },
                        ]}
                    />
                    <Column
                        dataField={"id"}
                        visibleIndex={1}
                        allowEditing={false}
                        caption={"#"}
                        width={80}
                    >
                        <FormItem visibleIndex={1} />
                    </Column>

                    <Column
                        dataField={"numero"}
                        visibleIndex={1}
                        allowEditing={false}
                        caption={"N.º"}
                        width={80}
                        sortIndex={1}
                        sortOrder={"desc"}
                    />

                    <Column dataField={"cv"} caption={"CV"} width={150} />

                    <Column
                        dataField={"prefeituraId"}
                        caption={"Prefeitura"}
                        visible={false}
                    />

                    <Column dataField={"dataEmissao"} caption={"Dt. Emissão"} width={150} format={"dd/MM/yyyy HH:mm:ss"} dataType={"datetime"} />
                    <Column dataField={"tomador"} caption={"Tomador"} />

                    <Column dataField={"valorTotal"} caption={"Valor Total (R$)"} width={180} format={uiInfo.formatoNumerico.n2} />

                    <Column dataField={"escrituradaStr"} caption={"Escriturada"} width={100} />

                    <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

                    <Pager
                        showInfo={true}
                        showNavigationButtons={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                    />
                </DataGrid>
            </div>
        </React.Fragment>
    );


}

export default RestaurarNfseBox;